import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useApiMutation } from "../../../Hooks/useApiMutation";
import instance from "../../../Interceptor/api_instance";
import FormBlock from "../../../Components/Inputs/FormBlock";
import { Spinner } from "../../../Components/LoadingAnimations/LoadingAnimations";
import { FormSelect } from "../../../Components/Inputs/FormInputs";

export const EmployeeCreated = ({ close, employee }) => {
  const { t } = useTranslation();
  return (
    <div className="page-mask page-mask-animation">
      <div className="white-cont">
        <h2>Employee Created</h2>
        <div className="form-group">
          <label className="input-label">
            {t("yard-tables.table-columns.name")}: {employee.full_name}
          </label>
        </div>
        <div className="form-group">
          <label className="input-label">
            {t("yard-tables.table-columns.title")}:{" "}
            {t(`yard-tables.table-columns.${employee.job_title.toLowerCase()}`)}
          </label>
        </div>
        <div className="form-group">
          <label className="input-label">Pin: {employee.employee_pin}</label>
        </div>
        <div className="">
          <button className="cancel-btn" onClick={close}>{t("buttons.close")}</button>
        </div>
      </div>
    </div>
  );
};

export const NewEmployee = ({ close, setCreated }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    title: "Guard",
  });

  const { mutate, isLoading, error, data } = useApiMutation(async (e) => {
    e.preventDefault();
    const response = await instance.post("/api/employees/", {
      first_name: formData.firstName,
      last_name: formData.lastName,
      job_title: formData.title,
    });
    if (response.status === 201) {
      setCreated(response.data);
      close();
    }
  });

  return (
    <div className="page-mask page-mask-animation">
      <div className="white-cont">
        <form onSubmit={mutate}>
          <FormBlock
            label={t("forms.type.newDriver.input-headers.firstName")}
            value={formData.firstName}
            update={(e) =>
              setFormData({ ...formData, firstName: e.target.value })
            }
            isRequired={true}
          />
          <FormBlock
            label={t("forms.type.newDriver.input-headers.lastName")}
            value={formData.lastName}
            update={(e) =>
              setFormData({ ...formData, lastName: e.target.value })
            }
            isRequired={true}
          />
          <div className="form-block">
            <label className="input-label required">
              {t("yard-tables.table-columns.title")}
            </label>
            <div className="input-cont">
              <select
                className="text-input"
                value={formData.title}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, title: e.target.value }))
                }
              >
                <option value="Guard">
                  {t("yard-tables.table-columns.guard")}
                </option>
                <option value="Mechanic">
                  {t("yard-tables.table-columns.mechanic")}
                </option>
              </select>
            </div>
          </div>
          {error && <p className="error">{error}</p>}
          <div className="full-cont">
            {isLoading ? (
              <Spinner />
            ) : (
              <>
                <button className="change-pwd-btn all-btn" type="submit">
                  {t("buttons.submit")}
                </button>
                <button
                  className="cancel-btn all-btn"
                  type="button"
                  onClick={close}
                >
                  {t("buttons.close")}
                </button>
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};
